// extracted by mini-css-extract-plugin
module.exports = {"chevron":"styles__chevron___3RW4d","right":"styles__right___352lJ","down":"styles__down___1mD2W","left":"styles__left___2Xt07"};